import Vue from 'vue';
import VeeValidate, {Validator} from 'vee-validate';
import zh from 'vee-validate/dist/locale/zh_CN'; // introducing Chinese files

// configuration Chinese
Validator.addLocale(zh);

const config = {
  locale: 'zh_CN'
};

Vue.use(VeeValidate,config);

// custom validate
const dictionary = {
   zh_CN: {
      messages: {
        email: () => '请输入正确的邮箱格式',
        required: ( field )=> "请输入" + field
      },
      attributes:{
        phone: '手机号',
        captcha: '验证码',
        password:'密码',
        username: '姓名',
        IDcard: '身份证号',
        email:'邮箱',
        address: '籍贯',
        province: '省份',
        city: '城市',
        wechat: '微信号',
        age: '年龄',
        workYear: '工作年限',
        degree: '学历',
        school: '就读学校',
        major: '专业',
        company: '公司',
        reason: '离职原因'
      }
  }
};

Validator.updateDictionary(dictionary);

Validator.extend('phone', {
  messages: {
    zh_CN:field => '请输入正确的' + field,
  },
  validate: value => {
    return value.length == 11 && /^([1][3-9][0-9]{9})$/.test(value);
  }
});

Validator.extend('password', {
  messages: {
    zh_CN:field => field + '必须在6-20位之间',
  },
  validate: value => {
    return value.length >= 6 && value.length <= 20;
  }
});

Validator.extend('captcha', {
  messages: {
    zh_CN:field => '请输入正确的' + field,
  },
  validate: value => {
    return value.length == 4;
  }
});

Validator.extend('IDcard', {
  messages: {
    zh_CN:field => field + '必须是18位',
  },
  validate: value => {
    return value.length == 18;
  }
});

Validator.extend('wechat', {
  messages: {
    zh_CN:field => field + '长度为6-20，子母、数字、下划线和减号, 非数字开头',
  },
  validate: value => {
    // 1、可以使用6-20个子母、数字、下划线和减号
    // 2、不能设置中文
    return value.length >= 6 && value.length <= 20 && /^[-_a-zA-Z][-_a-zA-Z0-9]{5,19}$/.test(value);
  }
});

Validator.extend('number', {
  messages: {
    zh_CN:field => field + '必须是整数',
  },
  validate: value => {
    return !isNaN(value) && value > 0;
  }
});

export default Validator;
